import { useTranslation } from 'react-i18next';
import { blogCategories } from '@/mocks/blogData';

interface BlogCategoryFilterProps {
  activeCategory: string | null;
  onCategoryChange: (categoryId: string | null) => void;
}

export default function BlogCategoryFilter({ activeCategory, onCategoryChange }: BlogCategoryFilterProps) {
  const { t } = useTranslation();

  return (
    <section className="py-8 bg-background-50 border-b border-background-200/50">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="flex flex-wrap items-center gap-2">
          <button
            onClick={() => onCategoryChange(null)}
            className={`px-4 py-2 text-[15px] tracking-[0.04em] rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer ${
              activeCategory === null
                ? 'bg-accent-500/90 text-primary-900 font-medium'
                : 'bg-background-100 text-foreground-600 hover:text-accent-600 hover:bg-background-200'
            }`}
          >
            {t('blog.list.all')}
          </button>
          {blogCategories.map((cat) => (
            <button
              key={cat.id}
              onClick={() => onCategoryChange(cat.id)}
              className={`px-4 py-2 text-[15px] tracking-[0.04em] rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer ${
                activeCategory === cat.id
                  ? 'bg-accent-500/90 text-primary-900 font-medium'
                  : 'bg-background-100 text-foreground-600 hover:text-accent-600 hover:bg-background-200'
              }`}
            >
              {t(`blog.cat.${cat.id}`, { defaultValue: cat.name })}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}